import EmptyList from "@/assets/empty_list.svg";
import { PlusIcon } from "lucide-react";
import { Button } from "@/components/ui/button";

interface EmptyTableProps {
  title: string;
  subtitle?: string;
  action?: () => void;
  actionTitle?: string;
}

const EmptyTable = ({
  action,
  actionTitle,
  title,
  subtitle,
}: EmptyTableProps) => {
  return (
    <div className="px-3 flex flex-col gap-y-4 py-8 lg:py-14 items-center justify-center">
      <img src={EmptyList} alt="Empty list" className="max-w-28" />
      <div className="my-2 text-center">
        <p className="font-medium text-lg text-balance pb-0.5">{title}</p>
        {subtitle && (
          <span className="text-balance text-gray-400">{subtitle}</span>
        )}
      </div>
      {action && actionTitle ? (
        <Button className="cursor-pointer" onClick={action}>
          <PlusIcon />
          {actionTitle}
        </Button>
      ) : null}
    </div>
  );
};

export default EmptyTable;
